import React from "react";
import Dropdown from "../DropDown";

interface FuelTypeDropdownProps {
  selectedFuelType: string;
  onFuelTypeChange: (selectedFuelType: string) => void;
  disabled: boolean;
  className?: string;
  onFocus?: () => void;
}

const FuelTypeDropdown: React.FC<FuelTypeDropdownProps> = ({
  selectedFuelType,
  onFuelTypeChange,
  className = "",
  disabled,
  onFocus,
}) => {
  const options = [
    { value: "ALL", label: "ALL" },
    { value: "BATTERY", label: "BATTERY" },
    { value: "GAS", label: "GAS" },
    { value: "SOLAR", label: "SOLAR" },
    { value: "STORAGE", label: "STORAGE" },
    { value: "WIND", label: "WIND" },
  ];

  return (
    <Dropdown
      options={options}
      selectedValue={selectedFuelType}
      onValueChange={onFuelTypeChange}
      disabled={disabled}
      className={className}
      placeholder="Select Fuel Type"
      onFocus={onFocus}
    />
  );
};

export default FuelTypeDropdown;
